import Constant from '@/const';
import axios from 'axios';

const getDiagnoseById = async id => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat(`/master/diagnose/${id}`),
    );
    return response.data.data;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default getDiagnoseById;
